import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { SiteMembership } from '../models/site-membership'
import { NginV2ApiService } from './nginV2Api.service'
import { Store } from './store'

@Injectable({
  providedIn: 'root'
})
export class SiteMembershipService extends Store<SiteMembership[]> {

  constructor(private api: NginV2ApiService) {
    super([])
  }

  public cancel(membership: SiteMembership): Observable<SiteMembership> {
    return this.api.put(`site_memberships/${membership.id}`, { status: 'declined'})
  }

  public findAll(personaId: string): Observable<SiteMembership[]> {
    return this.api.findAllAs<SiteMembership>(
      `site_memberships?persona_id=${personaId}`, { }, SiteMembership)
  }

}
